import { SearchApi } from '@occ/api-client';

const searchApi = new SearchApi({
  baseUrl: '',
});

export const getOfflinePreviewCampaigns = async (
  q?: string,
  fields?: Array<string>,
  page?: number,
  size?: number,
  dateFrom?: number,
  dateTo?: number
) => {
  const response = await searchApi.getOfflineCampaignsPreviewUsingGet({
    q,
    fields,
    page,
    size,
    dateFrom,
    dateTo,
  });
  return response.data;
};

export const getOfflineCampaigns = async (q: string, type?: string, page?: number, size?: number) => {
  const response = await searchApi.getOfflineCampaignsUsingGet(
    {
      q,
      type,
      page,
      size,
    },
    { format: 'json' }
  );
  return response.data;
};

export const getOnlineCampaigns = async (q: string, type?: string, page?: number, size?: number) => {
  const response = await searchApi.getOnlineCampaignsUsingGet(
    {
      q,
      type,
      page,
      size,
    },
    { format: 'json' }
  );
  return response.data;
};
